export default function Terms() {
  return (
    <div className="min-h-screen bg-background text-foreground px-6 py-12 max-w-3xl mx-auto" style={{ paddingTop: "max(3rem, env(safe-area-inset-top))", paddingBottom: "max(3rem, env(safe-area-inset-bottom))" }}>
      <h1 className="text-2xl font-bold mb-6">Terms of Service</h1>
      <p className="text-sm text-muted-foreground mb-4">Last updated: March 21, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold mb-2">Overview</h2>
          <p>
            HELLA Organized is an AI-powered productivity platform provided by HELLA Intelligence LLC. By using the app, you agree to these terms.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Your Account</h2>
          <p>
            You are responsible for maintaining the security of your account credentials and connected integrations. You agree not to share your account or use the service for any unlawful purpose.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Service Description</h2>
          <p>
            HELLA Organized provides task management, email aggregation, AI-assisted prioritization, calendar integration, meeting transcript processing, and team delegation tools. The service connects to third-party platforms (Gmail, Google Calendar, Fireflies, Plaud) with your explicit authorization.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">AI Features</h2>
          <p>
            The app uses AI (Anthropic's Claude) to classify emails, extract action items, generate documents, and assist with task management. AI-generated content is provided as-is and should be reviewed before acting on it. We are not responsible for AI-generated content accuracy.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Data Ownership</h2>
          <p>
            You retain full ownership of your data. We do not claim any rights to your emails, documents, tasks, or any content processed through the app. See our Privacy Policy for details on data handling.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Limitation of Liability</h2>
          <p>
            HELLA Intelligence LLC provides this service "as is" without warranty. We are not liable for any damages arising from use of the service, including but not limited to data loss, missed communications, or actions taken based on AI recommendations.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Contact</h2>
          <p>
            HELLA Intelligence LLC<br />
            Email: skyler@hellaintel.com<br />
            Website: hellaintel.com
          </p>
        </section>
      </div>
    </div>
  );
}
